'use client'

import { useEffect } from 'react'

type SiteErrorPageProps = {
  error: Error & { digest?: string }
  reset: () => void
}

export default function SiteErrorPage({ error, reset }: SiteErrorPageProps) {
  useEffect(() => {
    console.error('site_route_error', error)
  }, [error])

  return (
    <section className="home-section">
      <div className="home-container">
        <div className="rounded-[28px] border border-red-400/20 bg-red-500/[0.07] p-6 backdrop-blur-md sm:p-8">
          <h2 className="home-card-title-sm mb-3 text-white">Не удалось загрузить страницу</h2>
          <p className="home-subnote mb-6 text-gray-300/90">
            Произошла ошибка при отрисовке. Попробуйте обновить страницу.
          </p>

          <button
            type="button"
            onClick={reset}
            className="rounded-xl border border-white/15 bg-white/10 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-white/20"
          >
            Попробовать снова
          </button>
        </div>
      </div>
    </section>
  )
}
